// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e6385b3","732":"6e949f26"}[chunkId] + ".chunk.js";
};